import {Link} from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Reveal from '../components/Reveal';
import SectionHead from '../components/SectionHead';
import ServicePanels from '../components/ServicePanels';
import ProcessSteps from '../components/ProcessSteps';
import Calculator from '../components/Calculator';
import CtaBand from '../components/CtaBand';
import HomeHero from '../components/HomeHero';
import TrustBar from '../components/TrustBar';
import Marquee from '../components/Marquee';
import TiltCard from '../components/TiltCard';
import {materials,projects} from '../data/site';

const {FiArrowRight,FiCheck}=FiIcons;
const marqueeItems=['Driveways','Patios','Pool Decks','Walkways','Old Chicago','Travertine','Marble'];
const reasons=[
  'Proper excavation and compacted base',
  'Clean,tight patterns and crisp edges',
  'Honest guidance on materials and care',
  'One team from first visit to final walkthrough'
];
const materialPhotos={
  'Old Chicago': {
    src: 'https://images.pexels.com/photos/220182/pexels-photo-220182.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=900',
    alt: 'Weathered brick with varied, aged tones',
    label: 'Weathered brick inspiration'
  },
  'Classic Brick': {
    src: 'https://images.pexels.com/photos/207142/pexels-photo-207142.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=900',
    alt: 'Traditional red brick texture',
    label: 'Red brick inspiration'
  },
  Travertine: {
    src: 'https://images.unsplash.com/photo-1572331165267-854da2b10ccc?auto=format&amp;fit=crop&amp;w=900&amp;q=85',
    alt: 'Natural stone beside a swimming pool',
    label: 'Poolside stone inspiration'
  },
  Marble: {
    src: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?auto=format&amp;fit=crop&amp;w=900&amp;q=85',
    alt: 'Light-toned stone in an outdoor pool setting',
    label: 'Light stone inspiration'
  }
};

function Home() {
  return (
    <>
      <HomeHero />
      <Marquee items={marqueeItems} />
      <TrustBar />
      <section className="py-24 md:py-32">
        <div className="wrap">
          <SectionHead eyebrow="What we build" title="Every surface," accent="done beautifully." text="Hover or tap a panel to explore. Four specialties,one standard." />
          <ServicePanels />
        </div>
      </section>
      <section className="bg-sand py-24 md:py-32">
        <div className="wrap">
          <SectionHead eyebrow="Paver styles" title="Choose a" accent="look you love." />
          <div className="grid gap-5 md:grid-cols-4">
            {materials.map((m,i)=> (
              <Reveal key={m.name} delay={i * 0.08}>
                <TiltCard>
                  <Link to="/materials" className="group block bg-bone p-4 shadow-[0_20px_50px_rgba(20,17,15,0.08)]">
                    <div className="relative h-48 overflow-hidden bg-stone/20">
                      <img
                        src={materialPhotos[m.name].src.replaceAll('&amp;','&amp;')}
                        alt={materialPhotos[m.name].alt}
                        loading="lazy"
                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                      />
                      <span className="absolute bottom-3 left-3 bg-ink/80 px-2.5 py-1.5 text-[9px] font-bold uppercase tracking-widest text-white backdrop-blur-sm">
                        {materialPhotos[m.name].label}
                      </span>
                    </div>
                    <h3 className="h-display mt-5 text-3xl">{m.name}</h3>
                    <p className="mt-1 text-xs text-stone">{m.mood}</p>
                  </Link>
                </TiltCard>
              </Reveal>
            ))}
          </div>
          <p className="mt-5 text-xs text-stone">Photos are material inspiration, not product samples or completed US Paver Co. installations. Confirm your selection with physical samples.</p>
          <Link to="/materials" className="mt-10 inline-flex items-center gap-3 border-b border-ink pb-2 text-xs font-bold uppercase tracking-widest transition-all hover:gap-6">
            Try them in our visualizer <SafeIcon icon={FiArrowRight} />
          </Link>
        </div>
      </section>
      <section className="py-24 md:py-32">
        <div className="wrap grid items-center gap-14 lg:grid-cols-2">
          <Reveal>
            <p className="eyebrow">Why US Paver Co.</p>
            <h2 className="h-display mt-4 text-5xl md:text-7xl">
              Built right from <em className="text-brick">the ground up.</em>
            </h2>
            <ul className="mt-8 space-y-4">
              {reasons.map((t)=> (
                <li key={t} className="flex items-start gap-3 text-sm leading-6">
                  <SafeIcon icon={FiCheck} className="mt-1 shrink-0 text-brick" />
                  {t}
                </li>
              ))}
            </ul>
            <Link to="/about" className="btn btn-line mt-10">Our Story</Link>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="group overflow-hidden">
              <img src={projects[1].image} alt="Warm outdoor living space" loading="lazy" className="aspect-[4/5] w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
            </div>
          </Reveal>
        </div>
      </section>
      <ProcessSteps />
      <Calculator />
      <CtaBand />
    </>
  );
}

export default Home;
